export default window._cmsContent['common/cookie-banner']